import React from "react";
import SpinnerButton from "./SpinnerButton";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { isEmpty } from "../utils";
import { SIZES } from "../utils/enums";

const GenericModal = ({
  open,
  onClose,
  onConfirm,
  title,
  body,
  confirmText = "Confirm",
  cancelText = "Cancel",
  confirmColor = "primary",
  Icon,
  loading = false,
}: {
  open: string;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  body: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  confirmColor?: string;
  Icon?: React.ElementType;
  loading?: boolean;
}) => {
  return (
    <Modal open={!isEmpty(open) ? true : false} onClose={onClose}>
      <Box className="bg-white p-6 rounded-2xl shadow-lg w-96 mx-auto mt-40 text-center">
        {Icon && (
          <div className="flex justify-center mb-4">
            {<Icon className="w-10 h-10 text-gray-700" />}
          </div>
        )}
        <h2 className="text-lg font-semibold mb-4">{title}</h2>
        <p className="text-gray-700 mb-6">{body}</p>
        <div className="flex justify-center space-x-4">
          <button className="btn btn-primary" onClick={onClose}>
            {cancelText}
          </button>
          <SpinnerButton
            variant={confirmColor}
            onClickHandler={onConfirm}
            loading={loading}
            size={SIZES.sm}
          >
            {confirmText}
          </SpinnerButton>
        </div>
      </Box>
    </Modal>
  );
};

export default GenericModal;
